import { Box, Typography } from '@mui/material';
import { useLocales } from 'src/locales';

export const EmptyFolder = () => {
  const { translate } = useLocales();
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography variant="caption" color="text.disabled">
        {translate('drive.this_folder_is_empty')}
      </Typography>
    </Box>
  );
};
